import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/create")({
  component: CreateRedirect,
});

function CreateRedirect() {
  return <Navigate to="/admin/compose" />;
}
